module.exports = function shuffle (array, rng) {
  rng = rng || Math.random

  var result = []

  for (var i = 0; i < array.length; ++i) {
    var j = Math.floor(rng() * (i + 1))

    if (j !== i) {
      result[i] = result[j]
    }

    result[j] = array[i]
  }

  return result
}



//////////////////
// WEBPACK FOOTER
// /data/s1059050/dom32291/dom32291/wp-content/themes/bizwest-theme/node_modules/fisher-yates/index.js
// module id = 6
// module chunks = 0